
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import PriceList, { PriceListItem } from '@/components/PriceList.vue';

interface PriceGroup {
  title: string;
  text?: string;
  list: PriceListItem[];
}

@Component({
  name: 'Prijzen',
  components: { Header, PriceList },
})
export default class Prijzen extends Vue {
  private priceGroups: PriceGroup[] = [];

  mounted(): void {
    this.loadPrices();
  }

  private loadPrices(): void {
    // Cache-bust so price edits made after deployment take effect immediately,
    // without waiting for browsers or CDNs to expire a cached copy.
    this.axios
      .get<PriceGroup[]>('/data/prijzen.json', {
        params: { v: Date.now() },
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
        },
      })
      .then((response) => {
        this.priceGroups = response.data;
      })
      .catch((error) => {
        console.error('Could not load prijzen.json', error);
      });
  }
}
